module.exports = __webpack_public_path__ + "img/1-iphone.b663d0f6.png";